// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/persons/persons-widget.scss
// module id = 538
// module chunks = 1